import { makeStyles } from '@material-ui/core/styles';

import { ChatEventUserMessageFragment } from '@spotify/confidence-graphql';

import { ResourceAttachmentChip } from '../AttachmentChip';
import { MarkdownContent } from '../MarkdownContent';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--bui-space-2)',
    marginLeft: 'auto',
    width: 'fit-content',
    maxWidth: '80%',
    padding: 'var(--bui-space-3) var(--bui-space-4)',
    backgroundColor: 'var(--bui-bg-surface-2)',
    borderRadius: 'var(--bui-radius-2)',
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--bui-space-2)',
    minWidth: 0,
  },
  attachments: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'var(--bui-space-2)',
  },
  text: {
    wordBreak: 'break-word',
  },
});

interface UserMessageProps {
  content?: string | null;
  parts?: ChatEventUserMessageFragment['parts'];
}

export const UserMessage = ({ content, parts }: UserMessageProps) => {
  const classes = useStyles();

  const attachmentParts = (parts ?? []).filter(p => p.resource);
  const textFromParts = (parts ?? [])
    .map(p => p.text)
    .filter((t): t is string => !!t)
    .join('\n\n');
  const bodyText = textFromParts || content || '';

  if (!bodyText && attachmentParts.length === 0) {
    return null;
  }

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        {attachmentParts.length > 0 && (
          <div className={classes.attachments}>
            {attachmentParts.map(part => (
              <ResourceAttachmentChip
                key={part.resource ?? ''}
                resourceName={part.resource ?? ''}
              />
            ))}
          </div>
        )}
        {bodyText && (
          <div className={classes.text}>
            <MarkdownContent>{bodyText}</MarkdownContent>
          </div>
        )}
      </div>
    </div>
  );
};
